import { UserService } from 'src/app/users/shared/user.service';
import { ProfileRelateExistingComponent } from '../profile-relate-existing/profile-relate-existing.component';
import { Subscription } from 'rxjs';
import { ProfileEditComponent } from '../profile-edit/profile-edit.component';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { ProfileService } from '../shared/profile.service';
import { ProfileRelationSearch } from '../shared/profile-relation-search.model';
import { ProfileRelationshipManagementDto } from '../shared/dto/profile-relationship-management.dto';
import { PagedResult } from 'src/app/shared/model/generic-paged-result.model';
import { ProfileRead } from '../shared/profile-read.model';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { ProfileNewComponent } from '../profile-new/profile-new.component';
import { NotificationService, TranslationService, DialogModal, DialogService } from 'src/app/shared';
import { RelationshipOptions } from '../shared/enum/relationship-options.enum';
import { ProfileRelationshipGridComponent } from './profile-relationship-grid/profile-relationship-grid.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'wl-profile-relationships',
  templateUrl: './profile-relationships.component.html',
  styleUrls: ['./profile-relationships.component.css'],
    standalone: false
})
export class ProfileRelationshipsComponent implements OnInit, OnDestroy {
  @Input() profileId: number;
  @ViewChild(ProfileEditComponent) profileEditComponent: ProfileEditComponent;
  @ViewChild(ProfileRelateExistingComponent) profileRelateExisting: ProfileRelateExistingComponent;
  @ViewChild(ProfileNewComponent) profileNewComponent: ProfileNewComponent;
  @ViewChild(ProfileRelationshipGridComponent) profileRelationshipGrid: ProfileRelationshipGridComponent;

  public profile: ProfileRead = new ProfileRead();
  public editProfileId = -1;
  public profileRelationships: PagedResult<Array<ProfileRelationshipManagementDto>>;
  public showPaging: boolean;
  public showEdit: boolean;
  public isSaving = false;
  private _routeSubscription: Subscription;
  private _profileRelationSubscription: Subscription;
  private _profileSubscription: Subscription;
  public relatedProfileAccess = 0;
  searchParams = new ProfileRelationSearch();

  constructor(
    private _profileService: ProfileService,
    private _route: ActivatedRoute,
    private ref: ElementRef,
    private _dialogService: DialogService,
    private _observationService: ObservationService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _userService: UserService,
    private _title: Title
  ) {}

  ngOnInit() {
    this._routeSubscription = this._route.params.subscribe((id) => {
      this.profileId = parseInt(id['id'], 10);
      this.loadRelations(1);
      this._profileService.getProfile(this.profileId).then((data) => {
        this.profile = data;
        this._title.setTitle(data.ReportName + ' ' + this._translationService.getInstant('common.profile.relationships'));
      });

      this._userService.getCurrentUserSecurityElementAccessLevel('ProfileRelated_Profiles_Tab').then((accessLevel: number) => {
        this.relatedProfileAccess = accessLevel;
      });
    });

    this._profileRelationSubscription = this._observationService.observeProfileRelations().subscribe((id) => {
      if (this.profileId === id) {
        this.loadRelations(1);
      }
    });

    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      if (this.profileId === id || this.profileRelationships.Result.findIndex((x) => x.RelProfileID === id)) {
        this.loadRelations(1);
      }
    });
  }

  ngOnDestroy() {
    if (this._routeSubscription) {
      this._routeSubscription.unsubscribe();
    }

    if (this._profileRelationSubscription) {
      this._profileRelationSubscription.unsubscribe();
    }

    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  onEditClicked(dto: ProfileRelationshipManagementDto) {
    this.showEdit = true;
    this.profileEditComponent.profileId = dto.RelProfileID;
    this.profileEditComponent.relatedProfileId = this.profileId;
    this.profileEditComponent.profileRelationId = dto.RelationID;
    this.profileEditComponent.setupComponentData();
  }

  onDeleteClicked(relationshipId: number) {
    const dialog = new DialogModal();
    dialog.yesText = this._translationService.getInstant('profiles.relationships.delete-relationship').toUpperCase();
    dialog.noText = this._translationService.getInstant('common.cancel').toUpperCase();
    dialog.headerText = this._translationService.getInstant('profiles.relationships.delete-relationship').toUpperCase();
    dialog.messageText = this._translationService.getInstant('profiles.relationships.delete-relationship-message');
    dialog.showCancel = false;
    dialog.show = true;
    dialog.yesFunction = () => {
      this._profileService.deleteProfileRelation(relationshipId).then((x) => {
        this._observationService.relationAdded(this.profileId);
        this.profileRelationshipGrid.search();
      });
    };
    this._dialogService.addDialog(dialog);
  }

  closeEdit() {
    this.showEdit = false;
  }

  saveOpenProfile() {
    this.isSaving = true;
    this.profileEditComponent.saveClick().then(() => {
      this.isSaving = false;
      this.showEdit = false;
      this.profileRelationshipGrid.search();
    });
  }

  private loadRelations(page: number) {
    const search = new ProfileRelationSearch();
    search.PageNumber = page;
    search.ProfileId = this.profileId;
    search.PageSize = 20;
    this.searchParams = search;
  }

  public relateExistingProfile() {
    this.profileRelateExisting.showRelatedModal = true;
  }

  public relateNewClick() {
    this.profileNewComponent.open();
  }
}
